module.exports = __webpack_public_path__ + "static/bett1aces_campaign_1920x1080_02-ec6ca877f558be3fd6c1f8788bd23f93.jpg";